<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" v-if="statuses.length">
				<span class="ml-2">فیلتر وضعیت:</span>
				<v-btn-toggle v-model="statusFilter" dense tile outlined color="purple mr-2">
					<v-btn v-for="status in statuses" :key="status" :value="status" small @click="selectedItems = []">
						{{ status }}
						<v-badge color="blue"
							:content="status === 'همه' ? items.length : items.filter(x => x.str_AgentStatus == status).length || '0'"
							inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="12" v-if="loanTypes.length">
				<span class="ml-2">فیلتر نوع وام:</span>
				<v-btn-toggle v-model="loanTypeFilter" dense tile outlined color="purple" class="mr-2 flex-wrap">
					<v-btn v-for="loanType in loanTypes" :key="loanType.id" :value="loanType.id" small>
						{{ loanType.title }}
						<v-badge color="blue"
							:content="loanType.id === 0 ? items.length : items.filter(x => x.loanModel.id == loanType.id).length || '0'"
							inline>
						</v-badge>
					</v-btn>
				</v-btn-toggle>
			</v-col>
			<v-col cols="8">
				<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید"
					single-line hide-details class="mb-5" />
			</v-col>
			<v-col cols="4">
				<div class="d-flex justify-end align-center">
					<export-excel :items="items" :headers="headers" :fileName="'لیست درخواست وام های نماینده'">
					</export-excel>
				</div>
			</v-col>
			<v-col cols="12">
				<v-data-table :headers="headers" :loading="loading" :items="filteredItems" :items-per-page="500" :search="search"
					class="elevation-1">
					<template v-slot:item="row">
						<tr>
							<td>
								<v-checkbox color="secondary" v-model="row.item.ch"
									@change="(val) => updateSelectedItems(val, row.item)" />
							</td>
							<td>
								<div>
									<small> شماره درخواست: </small>
									<small class="grey--text">
										{{ row.item.code }}
									</small>
								</div>
								<div>
									<small> نام مشتری: </small>
									<small class="grey--text">
										{{ row.item.memberModel.fullName }}
									</small>
								</div>
								<div>
									<small> عنوان وام: </small>
									<small class="grey--text">
										{{ row.item.loanModel.title }}
									</small>
								</div>
								<div>
									<small> مبلغ: </small>
									<small class="grey--text">
										{{ row.item.amount.toString().toPriceFormat() }}
									</small>
								</div>
								<div>
									<small> تاریخ درخواست: </small>
									<small class="grey--text">
										{{ `${row.item.requestDate_Persian.date} ${row.item.requestDate_Persian.time}` }}
									</small>
								</div>
							</td>
							<td class="text-center">
								{{ row.item.str_AgentStatus }}
							</td>
							<td class="text-center">
								<div>{{ row.item.userLoan ? row.item.userLoan.loanModel.title : 'انجام نشده است' }}</div>
								<div v-if="row.item.userLoan" class="grey--text">شماره وام: {{ row.item.userLoan ? row.item.userLoan.code
									: '' }}</div>
							</td>
							<td class="text-right">
								<div v-if="row.item.userLoan">
									<div>
										<small>سررسید تسویه با شما: </small>
										<small class="grey--text">{{ row.item.userLoan && row.item.userLoan.agentDueDate_Persian ?
											row.item.userLoan.agentDueDate_Persian.date : '' }}</small>
									</div>
									<div>
										<small>سهم شما: </small>
										<small class="grey--text">{{ row.item.userLoan ?
											row.item.userLoan.agentPrice.toString().toPriceFormat() : '' }}</small>
									</div>
									<div>
										<small>مجموع واریز اسپانسر به شما: </small>
										<small class="grey--text">{{
											row.item.userLoan ? row.item.userLoan.sumSponsorPayments.toString().toPriceFormat() : '' }}</small>
									</div>
								</div>
								<div class="red--text" v-else>
									<small>
										اطلاعات تسویه پس از تبدیل به وام فعال می شود.
									</small>
								</div>
							</td>
							<td class="text-right">
								<div v-if="row.item.userLoan">
									<div>
										<small>سررسید تسویه با نماینده: </small>
										<small class="grey--text">{{ row.item.userLoan && row.item.userLoan.subAgentDueDate_Persian ?
											row.item.userLoan.subAgentDueDate_Persian.date : '' }}</small>
									</div>
									<div>
										<small>سهم نماینده: </small>
										<small class="grey--text">{{ row.item.userLoan ?
											row.item.userLoan.subAgentPrice.toString().toPriceFormat() : ''
										}}</small>
									</div>
									<div>
										<small>مجموع واریز شما به نماینده: </small>
										<small class="info--text" style="cursor: pointer;"
											@click="subAgentTransactionList(row.item.userLoan)">{{
												row.item.userLoan ? row.item.userLoan.sumParentAgentPayments.toString().toPriceFormat() : ''
											}}</small>
										<div class="text-center">
											<v-btn color="secondary" @click="subAgentTransaction(row.item.userLoan)" x-small>ثبت واریزی</v-btn>
										</div>
									</div>
								</div>
								<div class="red--text" v-else>
									<small>
										اطلاعات تسویه پس از تبدیل به وام فعال می شود.
									</small>
								</div>
							</td>
							<!-- <td class="text-center">
								<v-btn class="mx-1" fab dark small color="secondary" @click="edit(row.item)">
									<v-icon dark>
										mdi-square-edit-outline
									</v-icon>
								</v-btn>
							</td> -->
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>

		<v-dialog v-model="dialogSubAgentTransaction" scrollable max-width="925px">
			<v-card>
				<v-card-title>
					<div><span class="headline"></span></div>
					<v-spacer />
					<v-btn @click="dialogSubAgentTransaction = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<ModifySubAgentTransaction v-if="dialogSubAgentTransaction" :data="selectedTransaction"
							@callbck="callbck_transaction" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogSubAgentTransactionsList" scrollable max-width="1200px">
			<v-card>
				<v-card-title>
					<div><span class="headline">لیست واریزی ها</span></div>
					<v-spacer />
					<v-btn @click="dialogSubAgentTransactionsList = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<SubAgentTransactions v-if="dialogSubAgentTransactionsList" :agent="agent" :userLoan="selectedUserLoan"
						@update="() => { loadData(); $emit('update') }" />
				</v-card-text>
			</v-card>
		</v-dialog>

		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import printJS from 'print-js'

	export default {
		name: 'AgentRequests',
		props: {
			agent: { type: Object },
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			ModifySubAgentTransaction: () => import('./ModifySubAgentTransaction'),
			SubAgentTransactions: () => import('./SubAgentTransactions.vue'),
			AgentTransactions: () => import('./AgentTransactions.vue'),
		},
		data() {
			return {
				selectedTransaction: null,
				selectedUserLoan: null,
				dialogSubAgentTransactionsList: false,
				dialogSubAgentTransaction: false,
				errorMessages: '',
				search: '',
				loading: false,
				headers: [
					{
						text: '',
						align: 'start',
						sortable: false,
						value: 'code',
						width: 20
					},
					{
						text: 'شماره درخواست',
						align: 'start',
						sortable: true,
						value: 'code',
						width: 225
					}, {
						text: 'وضعیت درخواست نماینده',
						align: 'center',
						sortable: true,
						value: 'str_AgentStatus',
					},
					{
						text: 'تبدیل درخواست به وام',
						align: 'center',
						sortable: true,
						value: 'userLoan.code',
						width: 150
					},
					{
						text: 'تسویه اسپانسر با شما',
						align: 'center',
						sortable: true,
						value: 'userLoan.agentDueDate_Persian',
						width: 200
					},
					{
						text: 'تسویه شما با نماینده',
						align: 'center',
						sortable: true,
						value: 'userLoan.subAgentPrice',
						width: 250
					}
				],
				items: [],
				dialog: false,
				selectedRequest: null,
				statuses: [],
				statusFilter: 'همه',
				selectedItems: [],
				loanTypes: [],
				loanTypeFilter: '',
			}
		},
		mounted() {
			this.loadData()
		},
		computed: {
			filteredItems() {
				if ((!(this.statusFilter || []).length || this.statusFilter === 'همه') && !this.loanTypeFilter)
					return this.items

				let clonedItems = []
				clonedItems.push(...this.items)

				if (this.statusFilter !== 'همه')
					clonedItems = clonedItems.filter(x => this.statusFilter.indexOf(x.str_AgentStatus) > -1)

				if (this.loanTypeFilter)
					clonedItems = clonedItems.filter(x => this.loanTypeFilter.indexOf(x.loanModel.id) > -1)

				return clonedItems
			}
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('agent/userLoanRequest/List?agentId=' + this.agent.id, null)
					.then(response => {
						this.items = response

						this.statuses = [...new Set(response.map(x => x.str_AgentStatus))]
						if (this.statuses.length)
							this.statuses.push('همه')

						this.loanTypes = Object.values(
							response.reduce((acc, obj) => ({ ...acc, [obj.loanModel.id]: obj.loanModel }), {})
						)
						if (this.loanTypes.length) {
							this.loanTypes.push({ id: 0, title: 'همه' })
							this.loanTypeFilter = 0
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			edit(item) {
				this.dialog = true
				this.selectedRequest = item
			},
			callbck(result) {
				// this.dialog = false
				if (result) {
					this.loadData()
					this.$emit('update')
				}
			},
			updateSelectedItems(state, row) {
				if (!row)
					return
				const index = this.selectedItems.findIndex(x => x.id === row.id)
				if (state) {
					if (index === -1)
						this.selectedItems.push(row)
				} else {
					if (index !== -1)
						this.selectedItems.splice(index, 1)
				}
			},
			selectionToggler(state) {
				if (state) {
					this.selectedItems = this.filteredItems.map(x => x)
				} else {
					this.selectedItems = []
				}
			},
			print() {
				printJS({
					printable: 'printHtml',
					type: 'html',
					scanStyles: true, // If true inline styles will be removed
					targetStyles: ['*'],
					style: [`#printHtml {display:block!important;}`]
				})
			},
			subAgentTransaction(item) {
				if (!item) {
					toast.error('وام مرتبط برای این درخواست هنوز ثبت نشده است، بنابراین امکان ثبت واریزی وجود ندارد.')
					return
				}
				this.selectedTransaction = {
					id: emptyId,
					paymentMethod: 2,
					isWithdraw: true,
					userLoan: {
						id: item.id,
						title: `شماره وام: ${item.code}, عنوان: ${item.loanModel.title}`,
						code: item.code,
						subAgentModel: {
							id: this.agent.id,
							businessName: this.agent.businessName,
							mobile: this.agent.mobile,
							firstName: this.agent.firstName,
							bankAccountsJson: this.agent.bankAccountsJson
						}
					},
					amount: Math.max(item.subAgentPrice - item.sumParentAgentPayments, 0),
					maxAmount: item.subAgentPrice - item.sumParentAgentPayments
				}
				this.dialogSubAgentTransaction = true
			},
			callbck_transaction(result) {
				this.dialogSubAgentTransaction = false
				if (result) {
					this.loadData()
					this.$emit('update')
				}
			},
			subAgentTransactionList(userLoan) {
				this.selectedUserLoan = userLoan
				this.dialogSubAgentTransactionsList = true
			},
		}
	}
</script>
<style></style>
